__turbopack_context__.v({
  "container": "StatisticTooltip-module-scss-module__XzM8ZG__container",
  "key": "StatisticTooltip-module-scss-module__XzM8ZG__key",
  "list": "StatisticTooltip-module-scss-module__XzM8ZG__list",
  "title": "StatisticTooltip-module-scss-module__XzM8ZG__title",
  "value": "StatisticTooltip-module-scss-module__XzM8ZG__value",
});
